import { Modal, Result, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { TransactionAction } from './types';

interface TransactionActionModalProps {
  action: TransactionAction | null;
  isSubmitting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

function TransactionActionModal({ action, isSubmitting, onConfirm, onCancel }: TransactionActionModalProps) {
  const { t } = useTranslation();
  const isDecline = action === 'DECLINE';

  return (
    <Modal open={action !== null} onCancel={onCancel} footer={null} width={400}>
      <Result
        status='warning'
        title={isDecline ? t('Sure to decline?') : t('Sure to confirm?')}
        extra={
          <Button type='primary' danger={isDecline} loading={isSubmitting} onClick={onConfirm}>
            {isDecline ? t('Reject') : t('Confirm')}
          </Button>
        }
      />
    </Modal>
  );
}

export default TransactionActionModal;
